import { z } from 'zod';

/**
 * クエリ文字列の真偽値。"1" / "true" だけ true、"0" / "false" / 空は false。
 * z.coerce.boolean() は文字列 "false" も true にしてしまう（Boolean('false') === true）ので、GET のクエリには必ずこちらを使う。
 */
export const zQueryBoolean = z
  .union([z.boolean(), z.string(), z.number()])
  .transform((v) => (typeof v === 'boolean' ? v : typeof v === 'number' ? v !== 0 : ['1', 'true', 'yes', 'on'].includes(v.trim().toLowerCase())));

export const zQueryBooleanDefault = (def: boolean) => zQueryBoolean.optional().transform((v) => (v === undefined ? def : v));
